<template>
  <mv-page>
    <v-flex xs1 class="hidden-md-and-down" style="position:fixed; top: 70px">
      <h2 class="font-weight-light">Настройки</h2>
    </v-flex>
    <mv-default-row>
      <v-layout row wrap>
        <v-flex d-flex xs12 md6 lg8>
          <settings-bio :profile="profile"></settings-bio>
        </v-flex>
        <v-flex d-flex xs12 md6 lg4>
          <settings-cards :profile="profile"></settings-cards>
        </v-flex>
        <v-flex d-flex xs12 md12 lg8>
          <settings-destinations :profile="profile"></settings-destinations>
        </v-flex>
        <v-flex d-flex xs12 md12 lg4>
          <v-layout column>
            <!-- <v-flex xs12 style="max-height: 190px">
              <settings-permissions :profile="profile"></settings-permissions>
            </v-flex> -->
            <v-flex xs12 d-flex>
              <settings-misc :profile="profile"></settings-misc>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>

<script>
import SettingsBio from '@/components/SettingsBio'
import SettingsCards from '@/components/SettingsCards'
import SettingsDestinations from '@/components/SettingsDestinations'
import SettingsPermissions from '@/components/SettingsPermissions'
import SettingsMisc from '@/components/SettingsMisc'
export default {
  data: () => ({}),
  components: {
    SettingsBio,
    SettingsCards,
    SettingsDestinations,
    SettingsPermissions,
    SettingsMisc
  },
  computed: {
    profile () {
      return this.$store.state.profile
    }
  }
}
</script>

<style lang="css">
</style>
